/*
 *  Author: DL
 *  Date: 2020-12-04 18:35:19
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-13 00:27:42
 *  LastEditors: DL
 *  Description: 搜索页面
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { useCallback, useRef, useState, useEffect } from 'react';
import { connect } from 'dva';
import router from 'umi/router';
import SearchDestination from '@/components/SearchDestination';
import Shortcut from '@/components/Shortcut';
import History from '@/components/History';
import FmapProvider from '@/components/FmapProvider';
import styles from './index.less';

function Search(props) {
    const { dispatch, fmap } = props;
    const { keyword } = props.location.query;

    const [search, setSearch] = useState('');
    const globalRef = useRef({ timeoutTimer: -1, preTime: 0 });
    const inputRef = useRef(null);

    const updateSearch = useCallback(keyword => {
        // if (keyword.trim()) {
        inputRef.current.focus();
        inputRef.current.value = keyword;
        router.replace({ search: `keyword=${keyword}` });
        setSearch(keyword);
        // }
    }, []);

    const handleSeachBackClick = useCallback(() => router.push('/home'), []);

    const handleShortcutClick = useCallback(keyword => updateSearch(keyword), [updateSearch]);

    const handleChangeKeyword = useCallback(
        event => {
            event.persist();
            const keyword = event.target.value;
            const nowTime = new Date().valueOf();
            const { preTime, timeoutTimer } = globalRef.current;

            if (nowTime - preTime < 500) {
                clearTimeout(timeoutTimer);
            }

            globalRef.current.timeoutTimer = setTimeout(() => {
                updateSearch(keyword);
            }, 500);

            globalRef.current.preTime = nowTime;
        },

        [updateSearch],
    );

    const handleLiClick = useCallback(
        focusModel => {

            dispatch({ type: 'map/updateFocusModel', payload: { focusModel: { ...focusModel } } });

            router.push('/home');

        },
        [dispatch],
    );

    useEffect(() => {
        updateSearch(keyword);
    }, [keyword, updateSearch]);

    return (
        <FmapProvider value={{ fmap }}>
            <div className={styles.wrapper}>
                <div className={styles.panel}>
                    <SearchDestination ref={inputRef} onClick={handleSeachBackClick} onChange={handleChangeKeyword} />
                    <Shortcut collapsible onClick={handleShortcutClick} />
                </div>
                <div className={styles.panel}>
                    <History keyword={search} onLiClick={handleLiClick} />
                </div>
            </div>
        </FmapProvider>
    );
}

export default connect()(Search);
